module.exports = __webpack_public_path__ + "media/step_1_da.108923a0.mp3";